import { useNavigate } from "@tanstack/react-router";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export const ReturnComplete = ({ returnData }) => {
  const navigate = useNavigate();
  // Handle Row click
  const handleClick = (params, event) => {
    const newURL = `/returns/pending/${returnData.data.data.returnOrder.no}`;
    navigate({ to: newURL });
  };
  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={1}>
        <Typography variant="h6" gutterBottom>
          Return {returnData.data.data.returnOrder.no} has been submitted.
        </Typography>
        {returnData.data.data.returnOrder.dropOff === "Yes" ? (
          <Typography>
            You will shortly recieve an email with your return label. Please
            apply this to the box and take it to your nearest drop-off point.
          </Typography>
        ) : (
          <Typography>
            We will contact you to confirm the collection date. Please ensure
            your parcel is ready for before the driver arrives.
          </Typography>
        )}
        <Box>
          <Button variant="contained" size="large" onClick={handleClick}>
            View Return
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};
